'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _reactIntl = require('react-intl');

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemSaveButton = require('./ItemSaveButton.scss');

var _ItemSaveButton2 = _interopRequireDefault(_ItemSaveButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemSaveButton = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ItemSaveButton, _Component);

    function ItemSaveButton() {
        (0, _classCallCheck3.default)(this, ItemSaveButton);
        return (0, _possibleConstructorReturn3.default)(this, (ItemSaveButton.__proto__ || (0, _getPrototypeOf2.default)(ItemSaveButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(ItemSaveButton, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['saved']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                save = _props.save,
                saved = _props.saved;

            var iconName = saved ? 'heart' : 'heart-o';
            var buttonClass = saved ? _ItemSaveButton2.default.button + ' ' + _ItemSaveButton2.default.saved : '' + _ItemSaveButton2.default.button;
            return (0, _jsx3.default)('div', {
                className: _ItemSaveButton2.default['live-item-save']
            }, void 0, (0, _jsx3.default)(_Button2.default, {
                className: buttonClass,
                onClick: save,
                secondary: true
            }, void 0, (0, _jsx3.default)(_caterwaulComponents.Icon, {
                className: _ItemSaveButton2.default.icon,
                name: iconName
            }), !saved ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'save_item'
            }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'item_saved'
            })), (0, _jsx3.default)('div', {
                className: _ItemSaveButton2.default['message-wrapper']
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemSaveButton2.default.title
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'interested_in_this_item'
            })), (0, _jsx3.default)('span', {
                className: _ItemSaveButton2.default.message
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'save_to_saved_items'
            }))));
        }
    }]);
    return ItemSaveButton;
}(_react.Component), _class.defaultProps = {
    saved: false
}, _temp);
exports.default = ItemSaveButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemSave/ItemSaveButton.js
// module id = +WQL
// module chunks = 46